<script setup lang="ts">
import { useLoaderStore } from "@/stores/loader";
import { onMounted, ref, watch } from 'vue'

const $store = useLoaderStore();
const $el = ref();

watch(
  () => $store.active,
  (active) => {
    if (active) {
      $el.value?.showModal();
    } else {
      $el.value?.close();
    }
  }
);

onMounted(
  () => {
    $el.value.addEventListener('cancel', (e: Event) => e.preventDefault());
  }
);
</script>

<template>
  <dialog ref="$el" :class="$style['loader']">
    <div :class="$style['shape-holder']">
      <svg :class="$style['letter-u']" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 331 401">
        <path fill="#365160"
              d="M281 0c-15 0-26 5-35 15-8 9-13 23-13 41v181c0 28-5 50-15 63s-28 19-53 19c-19 0-34-3-43-9-10-7-17-15-20-27-5-12-7-28-7-48V56c0-18-4-32-13-41C74 5 62 0 47 0 33 0 22 5 13 15 4 24 0 38 0 56v175c0 29 3 54 9 75 7 21 17 39 31 53s32 24 54 31a267 267 0 0 0 141 0 134 134 0 0 0 50-29c17-16 29-34 35-55 6-20 9-45 9-75V56c0-18-5-32-14-42-8-9-20-14-34-14Z"/>
      </svg>
      <span :class="$style['ring-shadow']">
        <svg :class="$style['ring']" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
          <circle class="loader-ring"
                  fill="transparent"
                  stroke-width="6px"
                  stroke="#41C8DB"
                  stroke-dashoffset="500"
                  stroke-dasharray="240.46 250.46"
                  stroke-linecap="round"
                  cx="50"
                  cy="50"
                  r="44"/>
          </svg>
      </span>
    </div>
    <div :class="$style['loading-text']">Loading...</div>
  </dialog>
</template>

<style module lang="scss">
.loader {
  overflow: hidden;
  background: none;
  border: none;
  position: fixed;
  top: 50%;
  z-index: 9999;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--u-color-primary-text);

  &::backdrop {
    background: rgba(255, 255, 255, 0.8);
    opacity: 1;
    //backdrop-filter: blur(1px);
  }
}

.shape-holder {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ring-shadow {
  filter: drop-shadow(0 3px 3px rgba(0, 0, 0, 0.25));
}

.ring {
  width: 100%;
  will-change: filter;
  animation: loader-spin 2s linear infinite;
}

.letter-u {
  height: 170px;
  position: absolute;
}

.loading-text {
  margin-top: 30px;
  text-transform: uppercase;
  color: var(--color-nevada-gray, #6d6e71);
  text-align: center;
  font-size: 25px;
  letter-spacing: 5px;
}

@keyframes loader-spin {
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
}
</style>
